export const DEFAULT_FEE_BPS = '55' // basis points
